import React, { useEffect, useMemo } from 'react';
import orderBy from 'lodash/orderBy';
import { useDispatch } from 'react-redux';

import { setInitialAcademyTopics } from 'features/classCreation';
import AttentionMark from 'components/AttentionMark';
import ClassCreationTrackerModal from '../ClassCreationTrackerModal';
import ErrorLayout from 'components/ErrorLayout';
import ScheduleClassesBulkEditRow from '../ScheduleClassesBulkEditRow';
import ScheduleClassRow from '../ScheduleClassRow';
import ScheduleConfrimationModal from '../ScheduleConfrimationModal';
import styles from './ScheduleLibraryClassesTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

function ScheduleLibraryClassesTable({ classes }) {
  const dispatch = useDispatch();
  const orderedClasses = useMemo(() => {
    return orderBy(classes, ['order'], ['asc']);
  }, [classes]);

  useEffect(() => {
    dispatch(setInitialAcademyTopics(orderedClasses));
  }, [dispatch, orderedClasses]);

  if (orderedClasses.length > 0) {
    return (
      <>
        <Table className={styles.table}>
          <TableHead className={styles.header}>
            <TableRow>
              <TableCell className={styles.titleCell}>
                Select Classes <AttentionMark />
              </TableCell>
              <TableCell className={styles.junctionCell}>Junction</TableCell>
              <TableCell className={styles.primaryInstructorCell}>
                Primary Instructor <AttentionMark />
              </TableCell>
              <TableCell className={styles.secondaryInstructorCell}>
                Secondary Instructor
              </TableCell>
              <TableCell className={styles.otherInstructorsCell}>
                Other Hosts
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <ScheduleClassesBulkEditRow />
            {orderedClasses.map((cls) => (
              <ScheduleClassRow
                key={cls.id}
                cls={cls}
              />
            ))}
          </TableBody>
        </Table>
        <ScheduleConfrimationModal classes={orderedClasses} />
        <ClassCreationTrackerModal classes={orderedClasses} />
      </>
    );
  } else {
    return (
      <ErrorLayout message="Selected library does not have any classes!" />
    );
  }
}

export default ScheduleLibraryClassesTable;
